import { render, staticRenderFns } from "./loadDetail.vue?vue&type=template&id=da75c198&"
import script from "./loadDetail.vue?vue&type=script&lang=js&"
export * from "./loadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports